import { Node } from "./node";
import { isObservable, observable } from "./observable";
export class IterableNode extends Node {
    constructor(initValue, origin, key) {
        super();
        this._origin = origin;
        this._name = key;
        this._memoValue = {}; // FIXME обманываем isTerminal
        if (!origin) {
            this._origin = observable(initValue);
        }
        // FIXME это не должно быть в конструкторе
        this._origin.$subscribe(this);
    }
    get $name() {
        return this._name;
    }
    // $publish(next: any, prev?: any, keys?: {[key: string]: any}): void {
    // }
    $each(f) {
        //        console.log('each')
        const origin = this._origin; //|| this//(this as ValueSet<T>)
        const v = origin.$value;
        // console.log('each', v)
        // console.log('each', (origin as any)._entries)
        for (let i in v) {
            f(origin.$at(i), i); // FIXME
        }
        //        console.log('each end')
        // if (Array.isArray(v)) {
        //     for (let i = 0; i < v.length; i++) {
        //         f(origin.$at(i))
        //     }
        // }
        // else {
        //     for (let i in v) {
        //         f(origin.$at(i as K))
        //     }    
        // }
        // origin.$ownKeys().forEach(i => {
        //     f(origin.$at(i as K))
        // })
    }
    $unsubscribe(subscription) {
        super.$unsubscribe(subscription);
        if (this._subscriptions.length == 0) {
            this._origin.$unsubscribe(this);
            this._origin = null;
            this._initialized = false;
            console.log('unsubscribed iterable detected [unsubscribe]');
        }
    }
}
export const iterable = (source, key = '__it') => {
    return (isObservable(source) ? new IterableNode(null, source, key) : new IterableNode(source, null, key));
};
export const isIterable = (v) => {
    return v != null && typeof v.$each === 'function';
};
export const iterator = (source, key = '__it') => {
    return iterable(source, key);
};
